import { NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';
import { CartPageLayoutHandler } from '@spartacus/cart/base/components';
import { MINI_CART_FEATURE } from '@spartacus/cart/base/root';
import { CmsConfig, provideConfig } from '@spartacus/core';

import { DpCartPageLayoutHandler } from './shared/handlers/cart-page-layout-handler';
import { DpCartNotificationService } from './shared/services/cart-notification.service';
import { CART_ADDITIONAL_FIELDS_FEATURE } from './store/cart-additional-fields-feature.constant';
import { cartAdditionalFieldsReducers } from './store/cart-additional-fields.reducers';

@NgModule({
  imports: [StoreModule.forFeature(CART_ADDITIONAL_FIELDS_FEATURE, cartAdditionalFieldsReducers)],
  providers: [
    DpCartNotificationService,
    { provide: CartPageLayoutHandler, useClass: DpCartPageLayoutHandler },
    provideConfig(<CmsConfig>{
      featureModules: {
        cartDetailsFeature: {
          cmsComponents: ['CartComponent'],
          module: () => import('./cart-details').then((m) => m.DpCartDetailsModule)
        },
        cartQuickOrder: {
          cmsComponents: ['CartQuickOrderComponent', 'CartQuickOrderFormComponent'],
          module: () =>
            import('./cart-quick-order').then(({ DpCartQuickOrderFormModule }) => DpCartQuickOrderFormModule)
        },
        cartTotals: {
          cmsComponents: ['CartTotalsComponent'],
          module: () => import('./cart-totals').then(({ DpCartTotalsModule }) => DpCartTotalsModule)
        },
        quickOrder: {
          cmsComponents: ['QuickOrderComponent'],
          module: () => import('./quick-order').then(({ DpQuickOrderListModule }) => DpQuickOrderListModule)
        },
        [MINI_CART_FEATURE]: {
          cmsComponents: ['MiniCartComponent'],
          module: () => import('./dp-mini-cart').then(({ DpMiniCartModule }) => DpMiniCartModule)
        },
        cartHeaderFeature: {
          cmsComponents: ['CartActionsComponent'],
          module: () => import('./cart-header').then((m) => m.DpCartHeaderModule)
        }
      }
    })
  ]
})
export class DpCartFeatureModule {
  constructor(_cartNotificationService: DpCartNotificationService) {
    // Intentional empty constructor
  }
}
